import { Button, Modal, Text } from "@oysterhr/ui"
import { Trans, useTranslation } from "react-i18next"
import LinkButton from "~/app/components/LinkButton"

type ConfirmMandateSignerModalValues = {
  signerEmail: string
  isUserSigner: boolean
}

type ConfirmMandateSignerProps = {
  values: ConfirmMandateSignerModalValues
  onRequestClose: () => void
  isOpen: boolean
  onConfirm: () => void
  onChangeSigner: () => void
}

export function ConfirmMandateSignerModal({
  values,
  onRequestClose,
  onConfirm,
  isOpen,
  onChangeSigner,
}: Readonly<ConfirmMandateSignerProps>) {
  const [t] = useTranslation(
    "company_interface/CompanyPaymentMethodsPage/ConfirmMandateSignerModal",
  )

  const onContinue = () => {
    onConfirm()
    onRequestClose()
  }

  return (
    <Modal onRequestClose={onRequestClose} isOpen={isOpen}>
      <Modal.Header>{t("confirmMandateSigner")}</Modal.Header>
      <Modal.Content>
        <div className="flex flex-col gap-4">
          <Text>
            <Trans
              defaults={t("modalMessage", { email: values.signerEmail })}
              components={{ b: <Text as="span" className="font-semibold" /> }}
            />
          </Text>
          <LinkButton className="!ml-0" emphasized onClick={onChangeSigner}>
            {t("changeSigner")}
          </LinkButton>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Button variation="secondary" onClick={onRequestClose}>
          {t("cancel")}
        </Button>
        <Button variation="primary" onClick={onContinue}>
          {t("continue")}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
